import { render, staticRenderFns } from "./tableReceive.vue?vue&type=template&id=855ff268"
import script from "./tableReceive.vue?vue&type=script&lang=js"
export * from "./tableReceive.vue?vue&type=script&lang=js"
import style0 from "./tableReceive.vue?vue&type=style&index=0&id=855ff268&prod&lang=css"
import style1 from "./tableReceive.vue?vue&type=style&index=1&id=855ff268&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports